import React from 'react';
import { CheckIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
const MOCKUP_URL = 'https://cdn.magicpatterns.com/uploads/2xmifi1VBLwQzFH6daxgeb/Portada_Desintoxica_tu_Mente_en_21_Dias.jpg';
const benefits = ['Un ejercicio práctico cada día', 'Sueño, hábitos digitales, movimiento y mente', 'Herramientas explicadas paso a paso'];
const indicators = [{
  icon: '📖',
  label: 'Guía práctica de 21 días'
}, {
  icon: '📥',
  label: 'Acceso inmediato'
}, {
  icon: '🔬',
  label: 'Incluye referencias científicas'
}];
export function Hero() {
  return <section className="pt-32 pb-20 md:pt-40 md:pb-28 bg-brand-cream overflow-hidden" data-id="element-86" data-mp="sai3509k0p57">
      <div className="max-w-[68rem] mx-auto px-6" data-id="element-87" data-mp="ncq2nhuufupe">
        <div className="flex flex-col md:flex-row md:items-center gap-14 md:gap-12" data-id="element-88" data-mp="nbyir4alzley">
          {/* Left — copy */}
          <div className="w-full md:w-[56%] flex flex-col items-start" data-id="element-89" data-mp="3cz5v8bjvq00c">
            <FadeIn delay={0.05} data-id="element-90" data-mp="380w0u35zb3fs">
              <p className="text-brand-forest text-xs md:text-sm font-semibold uppercase tracking-[0.18em] mb-5" data-id="element-91" data-mp="3j8iwsycd6eu6">
                Guía práctica de 21 días
              </p>
            </FadeIn>

            <FadeIn delay={0.12} data-id="element-92" data-mp="3o59ajf0p4ycf">
              <h1 className="font-serif font-bold text-4xl md:text-5xl lg:text-[3.75rem] leading-[1.08] mb-6" style={{
              color: '#0D1B2A'
            }} data-id="element-93" data-mp="39b4fyxmj3o1c">
                21 días para bajar
                <br data-id="element-94" data-mp="30g6kbirzxx6b" />
                el ruido mental
              </h1>
            </FadeIn>

            <FadeIn delay={0.18} data-id="element-95" data-mp="35au9zkyqkxmh">
              <p className="text-lg text-brand-gray leading-relaxed max-w-xl mb-8" data-id="element-96" data-mp="2qkdba9dhklta">
                Un plan práctico, día a día, para reducir la sobrecarga
                cotidiana, recuperar claridad y construir hábitos para una mente
                más tranquila.
              </p>
            </FadeIn>

            <FadeIn delay={0.24} data-id="element-97" data-mp="2ll0dwuoznwcg">
              <ul className="flex flex-col gap-3.5 mb-10" data-id="element-98" data-mp="2lk8ra9ddd8yb">
                {benefits.map(benefit => <li key={benefit} className="flex items-start gap-3" data-id="element-99" data-mp="s3cloaja7jqk">
                    <span className="flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center mt-0.5" style={{
                  backgroundColor: '#A7D7C5'
                }} aria-hidden="true" data-id="element-100" data-mp="najg5kfzo7df">
                      <CheckIcon className="w-3.5 h-3.5 text-brand-forest" strokeWidth={3} data-id="element-101" data-mp="1azkqjd8dtslc" />
                    </span>
                    <span className="text-base md:text-lg font-medium text-brand-charcoal leading-snug" data-id="element-102" data-mp="111ohcqz097pv">
                      {benefit}
                    </span>
                  </li>)}
              </ul>
            </FadeIn>

            <FadeIn delay={0.3} className="w-full sm:w-auto" data-id="element-103" data-mp="3lqm25xlrf3ue">
              <button onClick={() => document.getElementById('pricing')?.scrollIntoView({
              behavior: 'smooth'
            })} className="w-full sm:w-auto bg-brand-terracotta text-white px-9 py-4 rounded-full text-base md:text-lg font-bold tracking-wide hover:bg-opacity-90 hover:scale-[1.03] transition-transform transition-colors duration-200 shadow-lg mb-8" data-id="element-104" data-mp="3hqkckmtau0vh">
                QUIERO EMPEZAR MIS 21 DÍAS →
              </button>
            </FadeIn>

            <FadeIn delay={0.36} data-id="element-105" data-mp="2kync3u4i0xbp">
              <ul className="flex flex-col sm:flex-row sm:flex-wrap gap-3 sm:gap-x-6 sm:gap-y-3 text-sm font-medium text-brand-charcoal" data-id="element-106" data-mp="2kxkktl39ksv9">
                {indicators.map(item => <li key={item.label} className="flex items-center gap-2" data-id="element-107" data-mp="2tztvcayj8m8n">
                    <span aria-hidden="true" data-id="element-108" data-mp="umpr24j3br02">{item.icon}</span>
                    {item.label}
                  </li>)}
              </ul>
            </FadeIn>
          </div>

          {/* Right — book mockup */}
          <div className="w-full md:w-[44%]" data-id="element-109" data-mp="4acnpgwqpx9j">
            <FadeIn delay={0.2} direction="left" data-id="element-110" data-mp="4d75t1sa75zs">
              <img src={MOCKUP_URL} alt="Portada del e-book Desintoxica tu Mente en 21 Días" className="w-full max-w-sm md:max-w-md mx-auto object-contain rounded-2xl" style={{
              boxShadow: '0 22px 45px rgba(13, 27, 42, 0.18)'
            }} data-id="element-111" data-mp="3vgni4u78vzrw" />
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}